import keys from "locale/keys";
import React from "react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "utils/constants";

import {
  CopyrightText,
  FooterContent,
  FooterLink,
  FooterWrapper,
  LinksContainer,
} from "./styled.components";

interface FooterProps {
  sidebarOpen?: boolean;
  fullWidth?: boolean;
}

const Footer = ({ sidebarOpen = true, fullWidth = false }: FooterProps) => {
  const { t } = useTranslation();

  return (
    <FooterWrapper
      component="footer"
      sidebarOpen={sidebarOpen}
      fullWidth={fullWidth}
    >
      <FooterContent>
        <CopyrightText>
          &copy; {new Date().getFullYear()} Panel Surveyspotter. All rights
          reserved.
        </CopyrightText>
        <LinksContainer>
          <FooterLink
            href={`${ROUTES.POLICIES}?tab=terms`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(keys.terms_of_service)}
          </FooterLink>
          <FooterLink
            href={`${ROUTES.POLICIES}?tab=privacy`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(keys.privacy_policy)}
          </FooterLink>
          <FooterLink
            href={`${ROUTES.POLICIES}?tab=cookies`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(keys.cookies_policy)}
          </FooterLink>
        </LinksContainer>
      </FooterContent>
    </FooterWrapper>
  );
};

export default Footer;
